import { useAutoSave } from '@hooks/useAutoSave'
import { useAppStore } from '@store'
import { Store } from '@types'
import { useEffect, useState } from 'react'

export function AutoSaveIndicator() {
  const { isSaving, lastSaved } = useAutoSave()
  const prefs = useAppStore((store) => store.prefs)
  const clientInfo = useAppStore((store) => store.clientInfo)

  const [showSavedIndicator, setShowSavedIndicator] = useState(false)

  
  const intervalMinutes = Number(prefs?.['AUTOGUARDADO']) || 0

  useEffect(() => {
    if (!isSaving && lastSaved) {
      setShowSavedIndicator(true)
      const timer = setTimeout(() => {
        setShowSavedIndicator(false)
      }, 20000) // 20 segundos Ver si se quiere + ó -

      return () => clearTimeout(timer)
    }
  }, [isSaving, lastSaved])

  if (intervalMinutes <= 0) return null

  if (!clientInfo.nombreProyecto || !clientInfo.idDisenos) return null

  if (!isSaving && !showSavedIndicator) return null

  const formatDateTime = (date: Date | null) => {
    if (!date) return '--/--/----\n--:--'
    const dateStr = date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
    const timeStr = date.toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit',
    })
    return `${dateStr}\n${timeStr}`
  }

  return (
    <div className='fixed bottom-4 left-4 flex items-center gap-1 rounded-md border-2 border-C/itemBorder bg-C/Color1 px-2 py-2 shadow-lg transition-all'>
      {isSaving ? (
        <>
          <div className='h-4 w-4 animate-spin rounded-full border-2 border-C/itemBorder ' />
          <span className='text-sm font-medium text-C/Color3'>💾 {'Guardando'}...</span>
        </>
      ) : (
        <>
          <div className='mb-8 h-2 w-2 animate-pulse rounded-full bg-green-500' />
          <div className='text-xs text-C/Color3'>
            <div> {'Último guardado'}:</div>
            <div className='whitespace-pre-line'>{formatDateTime(lastSaved)}</div>
          </div>
        </>
      )}
    </div>
  )
}
